import { Controller } from "@hotwired/stimulus"

// § 3.8 Tier 6 Step 77 — toggle the amber "ConsLog will overwrite the
// cloud version every time" warning when the radio for `local_wins`
// is selected. The warning is the differentiating UX for the only
// destructive conflict policy; it must surface immediately on
// selection, not just on save.
export default class extends Controller {
  static targets = ["warning"]

  policyChanged(event) {
    if (!this.hasWarningTarget) return
    const value = event.currentTarget?.value
    if (value === "local_wins") {
      this.warningTarget.classList.remove("hidden")
    } else {
      this.warningTarget.classList.add("hidden")
    }
  }
}
